import { __rest } from "tslib";
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { containsNode } from '../../utils/dom';
import { useDropdown } from '../dropdown';
import { context, useNativeSelect } from './utils';
import SimpleButton from './button.simple';
const Button = (_a) => {
    var { dataTest: externalDataTest, onClick } = _a, props = __rest(_a, ["dataTest", "onClick"]);
    const controlRef = useRef(null);
    const infoRef = useRef(null);
    const { select, handleChange } = useNativeSelect();
    const { opened, registerControl, toggle } = useDropdown();
    const { info, registerInfoControl, native, dataTest: contextDataTest } = useContext(context);
    useEffect(() => {
        if (!controlRef.current) {
            return;
        }
        registerControl(controlRef.current);
    }, [registerControl, registerInfoControl]);
    useEffect(() => {
        if (!infoRef.current) {
            return;
        }
        registerInfoControl(infoRef.current);
    }, [registerInfoControl, info.show]);
    const handleClick = useCallback(evt => {
        if (infoRef.current && containsNode(infoRef.current, evt.target)) {
            evt.preventDefault();
            evt.stopPropagation();
            return;
        }
        toggle();
        if (onClick) {
            onClick(evt);
        }
    }, [toggle, onClick]);
    return (React.createElement(SimpleButton, Object.assign({}, props, { dataTest: contextDataTest ? `${contextDataTest}-button` : externalDataTest, controlRef: controlRef, onToggle: (_v, ev) => (native ? void 0 : handleClick(ev)), opened: opened, info: info, infoRef: infoRef, native: native, nativeSelectRef: select, nativeHandleChange: handleChange })));
};
export default Button;
//# sourceMappingURL=button.js.map